import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import {
  Dialog,
  Typography,
  Button,
  DialogActions,
  DialogContent,
  AppBar,
  Container,
  Toolbar,
  IconButton,
  TextField,
  Tooltip,
} from '@mui/material';
import NotesIcon from '@mui/icons-material/Notes';
import EditIcon from '@mui/icons-material/Edit';
import EditOffIcon from '@mui/icons-material/EditOff';
import { userDataAtom } from '../../../Atoms';

const CallNotesDialog = function CallNotesDialog({
  open,
  close,
  disableEdit,
  handleEditNotes,
  notesTxt = null,
  id = null,
  editUnavailable = false,
}) {
  const intl = useIntl();
  const userData = useAtomValue(userDataAtom);

  const [editNotes, setEditNotes] = useState(false);
  const [inputValue, setInputValue] = useState(notesTxt);

  const handleToggleEdit = () => {
    setEditNotes(!editNotes);
  };

  useEffect(() => {
    setEditNotes(false);
    setInputValue(notesTxt);
  }, [notesTxt]);

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="xs">
      <AppBar
        sx={{
          backgroundColor: 'primary.main',
          color: 'white.main',
          position: 'relative',
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <NotesIcon />
          <Typography variant="subtitle1" sx={{ ml: '8px' }}>
            {intl.messages.NOTES}
          </Typography>
          <Tooltip
            title={
              editNotes ? intl.messages.REMOVE_EDIT : intl.messages.EDIT_NOTES
            }
            placement="top"
          >
            {!disableEdit && (
              <IconButton onClick={handleToggleEdit} disabled={editUnavailable}>
                {editNotes ? (
                  <EditOffIcon sx={{ color: 'white.main' }} />
                ) : (
                  <EditIcon sx={{ color: 'white.main' }} />
                )}
              </IconButton>
            )}
          </Tooltip>
        </Toolbar>
      </AppBar>
      <DialogContent>
        {editNotes ? (
          <TextField
            id="notes"
            label={intl.messages.NOTES}
            multiline
            rows={10}
            value={inputValue}
            placeholder={intl.messages.INSERT_NOTES}
            onInput={(e) => {
              setInputValue(e.target.value);
            }}
            fullWidth
          />
        ) : (
          <Container>
            <Typography
              variant="subtitle1"
              sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}
            >
              {notesTxt || intl.messages.UNAVAILABLE}
            </Typography>
          </Container>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={close} fullWidth variant="text">
          {intl.messages.CLOSE}
        </Button>
        {editNotes && (
          <Button
            onClick={() =>
              handleEditNotes({
                id,
                notes: inputValue,
                userId: userData?.id,
              })
            }
            fullWidth
          >
            {intl.messages.CONFIRM}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

CallNotesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  notesTxt: PropTypes.string,
  handleEditNotes: PropTypes.func.isRequired,
  id: PropTypes.string,
  editUnavailable: PropTypes.bool,
  disableEdit: PropTypes.bool,
};

export default CallNotesDialog;
